<template>
  <v-row v-if="filters">
    <v-col
      :cols="colWidth"
      class="pr-0"
      v-for="(f, vi) in filters"
      :key="'v' + vi"
    >
      <v-row dense v-if="!dense"
        ><v-col class="rm-label">{{ f.name }}</v-col></v-row
      >
      <v-row dense>
        <v-col v-if="f.treePicker">
          <HierarchyTreeFilter
            :filter="f"
            :dense="dense"
            @change="$emit('filterChanged', f)"
          />
        </v-col>
        <v-col v-else-if="f.listValues">
          <v-autocomplete
            dense
            hide-details
            :label="dense ? f.name + ' Filter' : null"
            outlined
            class="rm-select"
            :items="f.listValuesFiltered"
            v-model="f.filterValues"
            @change="$emit('filterChanged', f)"
            multiple
            clearable
            :title="f.name + ' Filter'"
          >
            <!-- <template v-slot:label>
                          <span style="font-size: 13px">{{ f.name }}</span>
                        </template> -->
            <template v-slot:selection="{ item, index }">
              <span
                style="font-size: 13px"
                v-if="item && index === 0 && f.filterValues.length === 1"
                class="blue--text text-caption"
                :title="f.filterValues.join(', ')"
              >
                {{ f.filterValues[0] }}
              </span>
              <span
                style="font-size: 13px"
                v-else-if="item && index === 0"
                class="blue--text text-caption"
                :title="f.filterValues.join(', ')"
              >
                ({{ f.filterValues.length }} item{{
                  f.filterValues.length > 1 ? "s" : ""
                }})
              </span>
            </template>
            <!--<template v-slot:item="{ item }">
                          <span style="font-size: 13px">{{ item }}</span>
                        </template> -->
          </v-autocomplete></v-col
        ><v-col v-else-if="f.showTextSearch">
          <v-text-field clearable outlined dense hide-details
            v-model="f.searchText" append-icon="mdi-magnify"
            @keypress.enter="$emit('textfilterChanged', f)"
            @click:append="$emit('textfilterChanged', f)"
            @click:clear="clearText(f)"></v-text-field>
        </v-col>
        <template v-else>
          <v-col><v-text-field clearable prefix=">=" v-model="f.rangeFrom" outlined dense hide-details 
            @change="$emit('filterChanged', f)" :rules="[rules.number]"
            @click:clear="clearRangeFrom(f)"></v-text-field></v-col>
          <v-col><v-text-field clearable prefix="<=" v-model="f.rangeTo" outlined dense hide-details 
            @change="$emit('filterChanged', f)" :rules="[rules.number]"
            @click:clear="clearRangeTo(f)"></v-text-field></v-col>
          <!-- <v-col cols="2"><v-icon @click:append-outer="$emit('applyMeasureFilter')">mdi-arrow-right-bold-box</v-icon></v-col> -->
        </template>
        </v-row
      >
    </v-col>
  </v-row>
</template>

<script>
import HierarchyTreeFilter from "@/components/jobArchitecture/HierarchyTreeFilter";

export default {
  name: "FilterOptions",
  components: {
    HierarchyTreeFilter,
  },
  props: {
    filters: [],
    dense: Boolean,
    columnSpace: Number,
  },
  data: function () {
    return {
      response: null,
      rules: { 
        number : value => {
          const pattern = /^[0-9]/;
          return !value || pattern.test(value) || "Must be a valid number";
        }
      },
    };
  },
  watch: {},
  computed: {
    colWidth() {
      const minColWidth = (24 / this.columnSpace).toFixed(0);
      if (this.filters.length * minColWidth > 12)
        return null;
      else
        return minColWidth;
    },
  },
  created() {},
  methods: {
    clearText(f) {
      f.searchText = "";
      this.$emit('textfilterChanged', f);
    },
    clearRangeFrom(f) {
      f.rangeFrom = null;
      this.$emit('filterChanged', f);
    },
    clearRangeTo(f) {
      f.rangeTo = null;
      this.$emit('filterChanged', f);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/vars";
